import {
  createStore,
  applyMiddleware,
} from 'redux';

import thunk from 'redux-thunk';

import rootReducer from './reducers';

const middlewares = [thunk];

export default (preloadedState = {}, customMiddleware = []) => createStore(
  rootReducer,
  preloadedState,
  applyMiddleware(...middlewares, ...customMiddleware),
);
